import styled from "styled-components";
import { theme } from "@src/theme";

export const TogglesContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${theme.margins.xl};
`;

export const TopBarControls = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  flex-wrap: wrap;
  overflow: visible;
  padding-right: 4px;
  box-sizing: border-box;
`;

export const ConversationSourcePill = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background-color: ${theme.colors.yellow};
  color: ${theme.colors.black};
  border-radius: 999px;
  padding: 4px 14px;
  max-width: 280px;
  min-height: 27px;
  box-sizing: border-box;
`;

export const ConversationMetaPills = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: flex-end;
`;

export const ConversationSourceText = styled.span`
  font-size: 15px;
  font-weight: 700;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${theme.colors.black};
`;

export const TabsContainer = styled.div`
  display: flex;
  gap: ${theme.margins.small};
  flex-wrap: wrap;
  margin-top: ${theme.margins.small};
`;

export const TabButton = styled.button<{ $active: boolean }>`
  box-sizing: border-box;
  background-color: ${(props) =>
    props.$active ? theme.colors.yellow : "transparent"};
  border: 1px solid ${theme.colors.yellow};
  color: ${(props) =>
    props.$active ? theme.colors.black : theme.colors.yellow};
  border-radius: 100px;
  min-width: 97.86px;
  height: 27.04px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 15.4px;
  font-weight: 700;
  line-height: 18px;
  position: relative;
  outline: none;

  &:hover {
    background-color: ${(props) =>
      props.$active ? theme.colors.yellow : "rgba(255, 240, 87, 0.08)"};
  }
`;

export const TabBadge = styled.span`
  position: absolute;
  top: -6px;
  right: -6px;
  background-color: ${theme.colors.yellow};
  color: ${theme.colors.black};
  border-radius: 50%;
  width: 15.51px;
  height: 15.51px;
  font-size: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: -0.02em;
  border: 1px solid ${theme.colors.black};
`;

export const ContentContainer = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
  border-top: 1px solid ${theme.colors.darkGray};
`;

export const FIGMA_SELECTED_ROW = "rgba(255, 240, 87, 0.1)";
export const FIGMA_BLOCKED_SIDEBAR_BG = "#392120";
export const FIGMA_BLOCKED_ROW_SELECTED = "rgba(170, 9, 9, 0.45)";
export const FIGMA_BLOCKED_ROW_HOVER = "rgba(170, 9, 9, 0.55)";
export const FIGMA_BLOCKED_MUTED_OPACITY = 0.35;
export const FIGMA_MESSAGES_HEADER_BG = "#1D1D1D";
export const FIGMA_SIDEBAR_BG = "#2A2A2A";
export const FIGMA_SIDEBAR_WIDTH = "392.54px";
export const FIGMA_AVATAR_SIZE = "45.58px";
export const FIGMA_ACTION_BUTTON_WIDTH = "97.86px";
export const FIGMA_ACTION_BUTTON_HEIGHT = "27.04px";
export const FIGMA_MESSAGE_TEXT = "#CECECE";
export const FIGMA_USER_NAME_PILL = "#D9D9D9";
export const FIGMA_CHAT_MESSAGE_MAX_WIDTH = "423px";
export const FIGMA_CHAT_COLUMN_MAX_WIDTH = "675px";
